import React, { useContext, useRef, useState } from "react";
import "../../common/style.css";
import LanguageContext from "../../../context/LanguageContext";

var jsonDataEn = require("./data-en.json");
var jsonDataFr = require("./data-fr.json");

const FlxdeckHeader = () => {
  const { language, setLanguage } = useContext(LanguageContext);
  const data = language === "en" ? jsonDataEn.data : jsonDataFr.data;
  return (
    <header className="header">
      <div className="logo">
        <img src={data.logo} alt="Logo" className="header-logo" />
        {data.logoTitle}
      </div>
      <span className={language === "en" ? "d-none" : "active language-button"} onClick={() => setLanguage("en")} data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
        EN
      </span>
      <span className={language === "fr" ? "d-none" : "active language-button"} onClick={() => setLanguage("fr")} data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
        FR
      </span>
    </header>
  );
};

export default FlxdeckHeader;
